import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["column", "setSort", "currentSort", "children", "cx", "classes", "className"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip, Group, Text, Table, Center, Loader } from '@mantine/core';
import { memo, useMemo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FactionIdToName, OtherFaction, BuildAdvantage } from '../utils.js';
import useStyles from './WarzoneTable.styles.js';
import { WarzoneProgress } from '../../factionalwarfare/progress/WarzoneProgress.js';
import { FindFactionColor } from '../../factionalwarfare/FactionColors.js';
import { Minmatar } from '../../logos/factions/Minmatar.js';
import { Amarr } from '../../logos/factions/Amarr.js';
import { Caldari } from '../../logos/factions/Caldari.js';
import { Gallente } from '../../logos/factions/Gallente.js';
import { Guristas } from '../../logos/factions/Guristas.js';
import { Angel } from '../../logos/factions/Angel.js';
import { useWarzoneMap } from '../context/warzone-map.js';
import { useWarzoneStatus } from '../context/warzone-status.js';
import { FWSupport } from '../../logos/factionalwarfare/FWSupport.js';
var Logos = {
  minmatar: Minmatar,
  amarr: Amarr,
  caldari: Caldari,
  gallente: Gallente,
  guristas: Guristas,
  angel: Angel,
  neutral: FWSupport
};
var TableRow = memo(function (_ref) {
  var solarsystemId = _ref.solarsystemId,
    name = _ref.name,
    constellation = _ref.constellation,
    factionName = _ref.factionName,
    attackingFaction = _ref.attackingFaction,
    attackerAdvantage = _ref.attackerAdvantage,
    defenderAdvantage = _ref.defenderAdvantage,
    adjacency = _ref.adjacency,
    occupierFaction = _ref.occupierFaction,
    contestedAmount = _ref.contestedAmount,
    isSelected = _ref.isSelected,
    className = _ref.className,
    classes = _ref.classes,
    cx = _ref.cx,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var Logo = Logos[factionName];
  var sections = useMemo(function () {
    return [{
      faction: FactionIdToName(attackingFaction),
      value: contestedAmount * 100,
      tooltip: "".concat((Math.round(contestedAmount * 100 * 100) / 100).toLocaleString(i18n.language), "%")
    }, {
      faction: FactionIdToName(occupierFaction),
      value: 100 - contestedAmount * 100
    }];
  }, [attackingFaction, occupierFaction, contestedAmount, i18n.language]);
  var _useMemo = useMemo(function () {
      var perc = attackerAdvantage.totalAmount - defenderAdvantage.totalAmount;
      var faction = "neutral";
      if (perc > 0) faction = FactionIdToName(attackerAdvantage.factionID);
      if (perc < 0) faction = FactionIdToName(defenderAdvantage.factionID);
      return {
        advantageFaction: faction,
        advantagePercentage: Math.abs(perc)
      };
    }, [attackerAdvantage, defenderAdvantage]),
    advantagePercentage = _useMemo.advantagePercentage,
    advantageFaction = _useMemo.advantageFaction;
  var clickHandler = useCallback(function (event) {
    if (onClick) onClick(_objectSpread(_objectSpread({}, event), {}, {
      data: solarsystemId
    }));
  }, [onClick, solarsystemId]);
  var dataProps = {};
  if (isSelected) dataProps["data-selected"] = true;
  return /* @__PURE__ */jsxs("tr", _objectSpread(_objectSpread({
    id: "solarsystem-".concat(solarsystemId),
    className: cx(className, classes[factionName]),
    onClick: clickHandler
  }, dataProps), {}, {
    children: [/* @__PURE__ */jsx("td", {
      className: classes.logo,
      children: /* @__PURE__ */jsx(Tooltip, {
        label: t("warzone.faction.".concat(factionName)),
        children: /* @__PURE__ */jsx(Logo, {})
      })
    }), /* @__PURE__ */jsx("td", {
      children: name
    }), /* @__PURE__ */jsx("td", {
      className: classes.columnConstellation,
      children: constellation
    }), /* @__PURE__ */jsx("td", {
      children: t("warzone.adjacency.".concat(adjacency))
    }), /* @__PURE__ */jsx("td", {
      className: classes.columnContested,
      children: /* @__PURE__ */jsxs(Group, {
        spacing: "xs",
        grow: true,
        noWrap: true,
        children: [/* @__PURE__ */jsx(WarzoneProgress, {
          sections: sections
        }), /* @__PURE__ */jsxs("span", {
          children: [(Math.round(contestedAmount * 100 * 100) / 100).toLocaleString(i18n.language), "%"]
        })]
      })
    }), /* @__PURE__ */jsx("td", {
      className: classes.columnAdvantage,
      children: /* @__PURE__ */jsxs(Text, {
        color: FindFactionColor(advantageFaction, {
          neutral: "dimmed"
        }),
        children: [advantagePercentage, "%"]
      })
    })]
  }));
});
TableRow.displayName = "WarzoneTableRow";
var TableSort = function TableSort(_ref2) {
  var column = _ref2.column,
    setSort = _ref2.setSort,
    currentSort = _ref2.currentSort,
    children = _ref2.children,
    cx = _ref2.cx,
    classes = _ref2.classes,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _currentSort = _slicedToArray(currentSort, 2),
    currentColumn = _currentSort[0],
    currentDirection = _currentSort[1];
  var sortAsc = useCallback(function () {
    return setSort([column, "asc"]);
  }, [column, setSort]);
  var sortDesc = useCallback(function () {
    return setSort([column, "desc"]);
  }, [column, setSort]);
  var sortIcon;
  var action = sortAsc;
  if (currentColumn === column) {
    sortIcon = currentDirection === "asc" ? "\u25B2" : "\u25BC";
    action = currentDirection !== "asc" ? sortAsc : sortDesc;
  }
  return /* @__PURE__ */jsx("th", _objectSpread(_objectSpread({
    onClick: action,
    className: cx(className, classes.headerCell),
    "data-sort": currentColumn === column ? true : void 0,
    "data-nosort": currentColumn === column ? void 0 : true
  }, rest), {}, {
    children: /* @__PURE__ */jsxs("div", {
      children: [children, /* @__PURE__ */jsx("span", {
        className: classes.sortIcon,
        children: sortIcon
      })]
    })
  }));
};
TableSort.displayName = "WarzoneTableSort";
var WarzoneTable = function WarzoneTable(_ref3) {
  var classNames = _ref3.classNames,
    styles = _ref3.styles,
    unstyled = _ref3.unstyled,
    _ref3$LoaderComponent = _ref3.LoaderComponent,
    LoaderComponent = _ref3$LoaderComponent === void 0 ? Loader : _ref3$LoaderComponent,
    _ref3$allowSelect = _ref3.allowSelect,
    allowSelect = _ref3$allowSelect === void 0 ? true : _ref3$allowSelect,
    _ref3$selectMode = _ref3.selectMode,
    selectMode = _ref3$selectMode === void 0 ? "text" : _ref3$selectMode,
    headerBackgroundColor = _ref3.headerBackgroundColor,
    onClick = _ref3.onClick;
  var _useStyles = useStyles({
      headerBackgroundColor: headerBackgroundColor
    }, {
      name: "WarzoneTable",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useState = useState(["name", "asc"]),
    _useState2 = _slicedToArray(_useState, 2),
    currentSort = _useState2[0],
    setSort = _useState2[1];
  var tableSortData = {
    currentSort: currentSort,
    setSort: setSort,
    classes: classes,
    cx: cx
  };
  var _useWarzoneMap = useWarzoneMap(),
    mapData = _useWarzoneMap.mapData,
    activeFactions = _useWarzoneMap.activeFactions,
    adjacencyMap = _useWarzoneMap.adjacencyMap,
    dataLoading = _useWarzoneMap.loading,
    setSelectedSystem = _useWarzoneMap.setSelectedSystem,
    selectedSystem = _useWarzoneMap.selectedSystem;
  var _useWarzoneStatus = useWarzoneStatus(),
    statusData = _useWarzoneStatus.statusData,
    oldStatusData = _useWarzoneStatus.oldStatusData;
  var clickHandler = useCallback(function (event) {
    if (onClick) onClick(event);
    if (!allowSelect || event.isDefaultPrevented()) return;
    if (event.preventDefault !== void 0) event.preventDefault();
    setSelectedSystem(event.data);
  }, [onClick, allowSelect, setSelectedSystem]);
  var tableData = useMemo(function () {
    if (!mapData || !statusData || !oldStatusData) return [];
    return Object.entries(mapData.systems).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        id = _ref5[0],
        data = _ref5[1];
      return [parseInt(id, 10), data];
    }).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        solarsystemId = _ref7[0],
        data = _ref7[1];
      var _statusData$find = statusData.find(function (_ref8) {
          var id = _ref8.solarsystemID;
          return id === solarsystemId;
        }),
        occupierFaction = _statusData$find.occupierFaction,
        contestedAmount = _statusData$find.contestedAmount,
        advantage = _statusData$find.advantage;
      var _oldStatusData$find = oldStatusData.find(function (_ref9) {
          var id = _ref9.solarsystemID;
          return id === solarsystemId;
        }),
        oldContestedAmount = _oldStatusData$find.contestedAmount;
      var factionName = FactionIdToName(occupierFaction);
      var attackingFaction = OtherFaction(activeFactions, occupierFaction);
      var attackerAdvantage = BuildAdvantage(attackingFaction, advantage);
      var defenderAdvantage = BuildAdvantage(occupierFaction, advantage);
      var resolvedAdvantageFaction = "neutral";
      var resolvedAdvantageAmount = 0;
      var perc = Math.round(attackerAdvantage.totalAmount - defenderAdvantage.totalAmount);
      if (perc > 0) resolvedAdvantageFaction = FactionIdToName(attackerAdvantage.factionID);
      if (perc < 0) resolvedAdvantageFaction = factionName;
      if (perc !== 0) resolvedAdvantageAmount = Math.abs(perc);
      var adjacency = adjacencyMap[solarsystemId];
      var active = contestedAmount > oldContestedAmount;
      return {
        solarsystemId: solarsystemId,
        name: data.name,
        constellation: data.con.name,
        factionName: factionName,
        adjacency: adjacency,
        occupierFaction: occupierFaction,
        attackingFaction: attackingFaction,
        contestedAmount: contestedAmount,
        oldContestedAmount: oldContestedAmount,
        attackerAdvantage: attackerAdvantage,
        defenderAdvantage: defenderAdvantage,
        resolvedAdvantageFaction: resolvedAdvantageFaction,
        resolvedAdvantageAmount: resolvedAdvantageAmount,
        isSelected: selectedSystem === solarsystemId,
        active: active,
        className: active ? classes.activeSystem : classes.passiveSystem
      };
    }).sort(function (_ref10, _ref11) {
      var aName = _ref10.name;
      var bName = _ref11.name;
      return aName.localeCompare(bName);
    });
  }, [mapData, statusData, oldStatusData, activeFactions, adjacencyMap, classes, selectedSystem]);
  var sortedData = useMemo(function () {
    var _currentSort2 = _slicedToArray(currentSort, 2),
      column = _currentSort2[0],
      direction = _currentSort2[1];
    var data = tableData;
    switch (column) {
      case "name":
        data = data.sort(function (_ref12, _ref13) {
          var aName = _ref12.name;
          var bName = _ref13.name;
          return aName.localeCompare(bName);
        });
        break;
      case "constellation":
        data = data.sort(function (_ref14, _ref15) {
          var aName = _ref14.constellation;
          var bName = _ref15.constellation;
          return aName.localeCompare(bName);
        });
        break;
      case "adjacency":
        data = data.sort(function (_ref16, _ref17) {
          var aName = _ref16.adjacency;
          var bName = _ref17.adjacency;
          return aName.localeCompare(bName);
        });
        break;
      case "contested":
        data = data.sort(function (_ref18, _ref19) {
          var aAmt = _ref18.contestedAmount;
          var bAmt = _ref19.contestedAmount;
          return aAmt - bAmt;
        });
        break;
      case "faction":
        data = data.sort(function (_ref20, _ref21) {
          var aFaction = _ref20.factionName;
          var bFaction = _ref21.factionName;
          return aFaction.localeCompare(bFaction);
        });
        break;
      case "advantage":
        data = data.sort(function (_ref22, _ref23) {
          var aAmt = _ref22.resolvedAdvantageAmount;
          var bAmt = _ref23.resolvedAdvantageAmount;
          return aAmt - bAmt;
        });
        break;
    }
    if (direction === "desc") data.reverse();
    return data;
  }, [tableData, currentSort]);
  return /* @__PURE__ */jsxs(Table, {
    className: cx(classes.root, selectMode === "background" ? classes.selectedBackground : classes.selectedText),
    verticalSpacing: 5,
    highlightOnHover: true,
    children: [/* @__PURE__ */jsx("thead", {
      className: classes.heading,
      children: /* @__PURE__ */jsxs("tr", {
        children: [/* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "faction"
        }, tableSortData), {}, {
          className: classes.factionHeaderCell
        })), /* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "name"
        }, tableSortData), {}, {
          children: t("warzone.table.name")
        })), /* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "constellation"
        }, tableSortData), {}, {
          className: classes.columnConstellation,
          children: t("warzone.table.constellation")
        })), /* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "adjacency"
        }, tableSortData), {}, {
          children: t("warzone.table.adjacency")
        })), /* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "contested"
        }, tableSortData), {}, {
          className: classes.contestedHeaderCell,
          children: t("warzone.table.contested")
        })), /* @__PURE__ */jsx(TableSort, _objectSpread(_objectSpread({
          column: "advantage"
        }, tableSortData), {}, {
          children: t("warzone.table.advantage")
        }))]
      })
    }), /* @__PURE__ */jsx("tbody", {
      children: dataLoading ? /* @__PURE__ */jsx("tr", {
        children: /* @__PURE__ */jsx("td", {
          colSpan: 6,
          style: {
            padding: "5rem"
          },
          children: /* @__PURE__ */jsx(Center, {
            children: /* @__PURE__ */jsx(LoaderComponent, {})
          })
        })
      }) : sortedData.map(function (row) {
        return /* @__PURE__ */jsx(TableRow, _objectSpread({
          onClick: clickHandler,
          classes: classes,
          cx: cx
        }, row), "table-row-".concat(row.solarsystemId));
      })
    })]
  });
};
export { WarzoneTable };